import { getStoryblokImageUrl } from "../../../helpers/images/getStoryblokImageUrl";
// import { NavigationCardShort } from "./NavigationCardShort";
import { CosmosTitle } from "@cosmos/web-react";
import classnames from "classnames/bind";
import Link from "next/link";
import styles from "./NavigationCard.module.css";

const cx = classnames.bind(styles);

export const NavigationCard = ({
  label,
  backgroundDesktopSrc,
  backgroundMobileSrc,
  // iconSrc,
  selected,
  onClick,
  dragProgress = 0,
  isCompact = false,
  isHomepage = false,
  href,
}: {
  label: string;
  backgroundDesktopSrc: string;
  backgroundMobileSrc: string;
  // iconSrc: string;
  selected?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  dragProgress?: number;
  isCompact?: boolean;
  isHomepage?: boolean;
  href: string;
}) => {
  return (
    <Link
      href={href}
      className={cx("container")}
      onClick={onClick}
      style={
        {
          "--fade-opacity-inverted": isNaN(dragProgress) ? 1 : 1 - dragProgress,
        } as React.CSSProperties
      }
      // TODO: aria-label: something like "Filter options by {interestGroup.title}"
    >
      <div
        className={cx("card")}
        data-selected={selected}
        data-variant={isCompact ? "compact" : "default"}
        data-homepage={isHomepage ? "true" : undefined}
      >
        <div className={cx("body")}>
          <div className={cx("content")}>
            <CosmosTitle
              className={cx("text")}
              appearance="light"
              kind="subtle"
              size="xx-small"
              tag="span"
              weight="bold"
            >
              {label}
            </CosmosTitle>
          </div>
          <picture>
            {isHomepage ? (
              <>
                <source
                  // use desktop images:
                  media="(width >= 650px)"
                  srcSet={[1, 1.5, 2]
                    .flatMap((dpiMultiplier) => dpiMultiplier * 170)
                    .map(Math.ceil)
                    .map((width) => {
                      const src = getStoryblokImageUrl(backgroundDesktopSrc, {
                        width,
                      });

                      return `${src} ${width}w`;
                    })
                    .join(",")}
                />
                <source
                  // Mobile background image:
                  srcSet={[1, 1.5, 2]
                    .flatMap((dpiMultiplier) => dpiMultiplier * 170)
                    .map(Math.ceil)
                    .map((width) => {
                      const src = getStoryblokImageUrl(backgroundMobileSrc, {
                        width,
                      });

                      return `${src} ${width}w`;
                    })
                    .join(",")}
                />
              </>
            ) : (
              <>
                <source
                  // short height background image:
                  media="(height <= 800px) and (width >= 1000px)"
                  srcSet={[1, 1.5, 2]
                    .flatMap((dpiMultiplier) => dpiMultiplier * 170)
                    .map(Math.ceil)
                    .map((width) => {
                      const src = getStoryblokImageUrl(backgroundMobileSrc, {
                        width,
                      });

                      return `${src} ${width}w`;
                    })
                    .join(",")}
                />
                <source
                  // Desktop background image:
                  media="(width >= 1000px)"
                  srcSet={[1, 1.5, 2]
                    .flatMap((dpiMultiplier) => dpiMultiplier * 170)
                    .map(Math.ceil)
                    .map((width) => {
                      const src = getStoryblokImageUrl(backgroundDesktopSrc, {
                        width,
                      });

                      return `${src} ${width}w`;
                    })
                    .join(",")}
                />
                <source
                  // Mobile background image:
                  srcSet={[1, 1.5, 2]
                    .flatMap((dpiMultiplier) => dpiMultiplier * 170)
                    .map(Math.ceil)
                    .map((width) => {
                      const src = getStoryblokImageUrl(backgroundMobileSrc, {
                        width,
                      });

                      return `${src} ${width}w`;
                    })
                    .join(",")}
                />
              </>
            )}
            <img
              alt=""
              className={cx("background-image")}
              // Ignore this `src`: actual computed 'src' is given by the <source/>'s above ^
              src={getStoryblokImageUrl(backgroundDesktopSrc)}
              sizes="170px" // Not *strictly* correct – just an approximation.
            />
          </picture>
          <div className={cx("overlay")}></div>
        </div>
      </div>
      {/* <div className={cx("short-card")} aria-hidden="true">
        <NavigationCardShort
          label={label}
          iconSrc={iconSrc}
          selected={selected}
          dragProgress={dragProgress}
        />
      </div> */}
    </Link>
  );
};
